import {database} from '../firebase';
import {get, ref} from 'firebase/database';
import {readyAuth} from './readyAuth';

const CACHE_KEY = 'ks_research_briefing';
const CACHE_TIME_KEY = 'ks_research_briefing_time';
const CACHE_DURATION = 15 * 60 * 1000;

export async function getLatestBriefing() {
  const cached = localStorage.getItem(CACHE_KEY);
  const cachedAt = Number(localStorage.getItem(CACHE_TIME_KEY));
  if (cached && Date.now() - cachedAt < CACHE_DURATION) return JSON.parse(cached);
  await readyAuth();
  const snapshot = await get(ref(database, 'research/latest'));
  if (!snapshot.exists()) return null;
  const value = snapshot.val();
  try {
    localStorage.setItem(CACHE_KEY, JSON.stringify(value));
    localStorage.setItem(CACHE_TIME_KEY, String(Date.now()));
  } catch (_) { /* cache storage is optional */ }
  return value;
}
